module.exports = __webpack_public_path__ + "static/media/machismo_fernando.28b39cc5.png";